import styles from './index.module.scss';
import { menuLinks } from '../../constants/constants';
import { Link } from 'react-router-dom';
import Logo from '../../icons/Logo/Logo';
import Switcher from '../Switcher';
import { useTheme } from '../../hooks/useTheme';
import { useWidth } from '../../hooks/useWidth';
import Burger from '../Burger';
import { useState } from 'react';

const Header = () => {
  const { isDarkTheme } = useTheme();
  const { width } = useWidth();
  const [toggleMenu, setToggleMenu] = useState<boolean>(false);

  const handleLink = () => {
    window.scrollTo(0, 0);
    setToggleMenu(!toggleMenu);
  };

  return (
    <header
      className={styles.header}
      style={{ backgroundColor: isDarkTheme === 'dark' ? '#0E1012' : 'white' }}
    >
      <div className={styles.headerContainer}>
        <Logo
          color={isDarkTheme === 'light' ? '#110229' : 'white'}
          top={'18%'}
          left={'40%'}
        />
        <Switcher />

        <nav
          className={`${styles.navMenu} ${
            toggleMenu ? styles.mobileActiveMenu : ''
          }`}
        >
          <ul>
            {menuLinks.map((item, index) => (
              <li key={index} onClick={handleLink}>
                <Link
                  to={item.link}
                  style={{
                    color: isDarkTheme === 'light' ? '#110229' : 'white',
                  }}
                >
                  {' '}
                  {item.text}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {width < 868 && (
          <Burger
            color={isDarkTheme === 'dark' ? 'white' : 'black'}
            background={isDarkTheme === 'light' ? 'black' : 'white'}
            toggleMenu={toggleMenu}
            setToggleMenu={setToggleMenu}
          />
        )}
      </div>
    </header>
  );
};

export default Header;
